
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function TrustSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLearnMoreClick = () => {
    navigate('/tokyo-airbnb-support');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const trustPoints = [
    {
      icon: 'ri-home-smile-line',
      title: t('home:trust.point1Title'),
      description: t('home:trust.point1Description'),
    },
    {
      icon: 'ri-file-list-3-line',
      title: t('home:trust.point2Title'),
      description: t('home:trust.point2Description'),
    },
    {
      icon: 'ri-calculator-line',
      title: t('home:trust.point3Title'),
      description: t('home:trust.point3Description'),
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('home:trust.point4Title'),
      description: t('home:trust.point4Description'),
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: t('home:trust.point5Title'),
      description: t('home:trust.point5Description'),
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-100 text-emerald-700 rounded-full mb-4">
            <i className="ri-shield-check-line"></i>
            <span className="text-sm font-medium">{t('home:trust.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            {t('home:trust.title')}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            {t('home:trust.subtitle')}
          </p>
        </div>

        {/* Trust points grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {trustPoints.map((point, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-slate-200"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className={`${point.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{point.title}</h3>
              <p className="text-slate-600 leading-relaxed">{point.description}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={handleLearnMoreClick}
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-slate-800 to-slate-900 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
          >
            <span>{t('home:trust.ctaButton')}</span>
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}